module.exports = __webpack_public_path__ + "static/img/13areaB_4.18eedfa.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/13areaB_4.png
// module id = 1111
// module chunks = 1